import React, { useEffect, useState } from 'react'
import adminServices from '../../services/AdminServices'
import { MdPeople, MdUpdate } from 'react-icons/md';
import { ImCancelCircle } from 'react-icons/im';
import { FaCheckCircle } from 'react-icons/fa';

function RequestStats() {
    const [statistics, setStatics] = useState()
    useEffect(() => {
        adminServices.requestStats().then(
            res => {
                setStatics(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }, [])
    useEffect(() => { }, [statistics])
    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Total Requests</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.total_requests}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3 ">
                            <span className="material-symbols-outlined"><MdUpdate className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Matched Requests</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.marched_requests}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><MdPeople className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Cancelled Requests</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.cancelled_requests}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><ImCancelCircle className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>

                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Completed Requests</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.completed_requests}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><FaCheckCircle className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RequestStats